import React from "react";

import Schedule from "./Schedule";

import type { JSX } from "react";

import type { Schedule as ScheduleType } from "../../../api/FastAPI.types";

interface ISchedules {
  setActiveBroadcastId: (broadcastId: string) => void;
  setActiveScheduleId: (scheduleId: string) => void;
  activeBroadcastId: string | null;
  schedules: ScheduleType[];
}

function Schedules({
  setActiveBroadcastId,
  activeBroadcastId,
  setActiveScheduleId,
  schedules,
}: ISchedules): JSX.Element {
  return (
    <div className="flex w-full basis-1/4 flex-col">
      {schedules.map((schedule) => (
        <Schedule
          key={schedule.uuid}
          activeBroadcastId={activeBroadcastId}
          broadcasts={schedule.broadcasts}
          framerate={schedule.framerate}
          id={schedule.uuid}
          setActiveBroadcastId={setActiveBroadcastId}
          setActiveScheduleId={setActiveScheduleId}
        />
      ))}
    </div>
  );
}

export default Schedules;
